import { gql, useMutation, useQuery } from '@apollo/client';
import {
  BrandKey,
  GetTagForTagEditQuery,
  GetTagForTagEditQueryVariables,
  UpdateBrandedContentForTagEditMutation,
  UpdateBrandedContentForTagEditMutationVariables,
} from '../../__generated__/queries-web';

const GET_TAG = gql`
  query GetTagForTagEdit($where: TagUniqueFilterInput!, $brandKey: BrandKey) {
    tag(where: $where) {
      id
      title
      slug
      type
      lang
      brandedContents(first: 1, where: { brandKey: $brandKey }) {
        id
        createdAt
        updatedAt
        body
        media
        isActive
      }
      articleUsages {
        total
      }
    }
  }
`;

export const useGetTag = ({
  id,
  brandKey,
}: {
  id: string;
  brandKey: BrandKey;
}) =>
  useQuery<GetTagForTagEditQuery, GetTagForTagEditQueryVariables>(GET_TAG, {
    variables: {
      where: {
        id,
      },
      brandKey,
    },
    notifyOnNetworkStatusChange: true,
  });

const UPDATE_BRANDED_CONTENT = gql`
  mutation UpdateBrandedContentForTagEdit(
    $data: TagBrandedContentUpdateInput!
    $where: TagBrandedContentUniqueFilterInput!
  ) {
    updateTagBrandedContent(data: $data, where: $where) {
      id
      body
      media
    }
  }
`;

export const useUpdateBrandedContent = () =>
  useMutation<
    UpdateBrandedContentForTagEditMutation,
    UpdateBrandedContentForTagEditMutationVariables
  >(UPDATE_BRANDED_CONTENT);
